import { InstantOAuthError, type OAuthScope } from './oauthCommon.ts';
import {
  type InstantDBOAuthAccessToken,
  type OAuthHandlerConfig,
  OAuthHandler,
} from './oauth.ts';
import {
  generatePermsTypescriptFile,
  permsTypescriptFileToCode,
} from './perms.ts';
import {
  type InstantAPIPlatformSchema,
  generateSchemaTypescriptFile,
  collectSystemCatalogIdentNames,
  validateSchema,
  SchemaValidationError,
} from './schema.ts';
import {
  apiSchemaToInstantSchemaDef,
  PlatformApi,
  translatePlanSteps,
} from './api.ts';
import { schemaTypescriptFileToInstantSchema } from './typescript-schema.ts';

import version from './version.ts';
import { ProgressPromise } from './ProgressPromise.ts';
import {
  i,
  type InstantRules,
  type InstantRouteHandlerPayloadByType,
  type InstantRouteHandlerType,
  type InstantRouteHandlerBody,
} from '@instantdb/core';
import { exchangeCodeForToken, exchangeRefreshToken } from './serverOAuth.ts';
import { clerkDomainFromPublishableKey } from './clerk.ts';
import {
  Webhooks,
  type WebhookAction,
  type WebhookStatus,
  type WebhookEventStatus,
  type WebhookInfo,
  type WebhookAttempt,
  type WebhookEventInfo,
  type WebhookEventsPage,
  type WebhookBody,
  type WebhookEntity,
  type WebhookPayload,
  type WebhookPayloadRecord,
  type WebhookPayloadRecordFor,
  type WebhookHandlerFn,
  type WebhookHandlers,
  type WebhookHelpers,
  type CreateWebhookParams,
  type UpdateWebhookParams,
  WebhooksManager,
} from '@instantdb/webhooks';

export {
  type InstantAPIPlatformSchema,
  type InstantDBOAuthAccessToken,
  type OAuthHandlerConfig,
  type OAuthScope,
  type InstantRules,
  type InstantRouteHandlerPayloadByType,
  type InstantRouteHandlerType,
  type InstantRouteHandlerBody,
  OAuthHandler,
  InstantOAuthError,
  generateSchemaTypescriptFile,
  collectSystemCatalogIdentNames,
  validateSchema,
  SchemaValidationError,
  generatePermsTypescriptFile,
  permsTypescriptFileToCode,
  apiSchemaToInstantSchemaDef,
  schemaTypescriptFileToInstantSchema,
  version,
  translatePlanSteps,
  PlatformApi,
  ProgressPromise,
  exchangeCodeForToken,
  exchangeRefreshToken,
  clerkDomainFromPublishableKey,
  i,
  Webhooks,
  WebhooksManager,
  type WebhookAction,
  type WebhookStatus,
  type WebhookEventStatus,
  type WebhookInfo,
  type WebhookAttempt,
  type WebhookEventInfo,
  type WebhookEventsPage,
  type WebhookBody,
  type WebhookEntity,
  type WebhookPayload,
  type WebhookPayloadRecord,
  type WebhookPayloadRecordFor,
  type WebhookHandlerFn,
  type WebhookHandlers,
  type WebhookHelpers,
  type CreateWebhookParams,
  type UpdateWebhookParams,
};

export {
  diffSchemas,
  convertTxSteps,
  isRenamePromptItem,
  buildAutoRenameSelector,
  type RenameResolveFn,
  type MigrationTx,
  type MigrationTxSpecific,
  type MigrationTxTypes,
  type Identifier,
} from './migrations.ts';

export {
  DEFAULT_OAUTH_CALLBACK_URL,
  GOOGLE_AUTHORIZATION_ENDPOINT,
  GOOGLE_DISCOVERY_ENDPOINT,
  GOOGLE_TOKEN_ENDPOINT,
  APPLE_AUTHORIZATION_ENDPOINT,
  APPLE_DISCOVERY_ENDPOINT,
  APPLE_TOKEN_ENDPOINT,
  LINKEDIN_AUTHORIZATION_ENDPOINT,
  LINKEDIN_DISCOVERY_ENDPOINT,
  LINKEDIN_TOKEN_ENDPOINT,
} from './consts.ts';
